import { Pipe, PipeTransform } from '@angular/core';
import {CustomerService} from '@app/core/service/customer.service';
import {
    CalendarModel,
    CourseModel,
    DistrictModel,
    GroupModel, Person,
    RosterModel,
    SchoolModel
} from '@app/views/databrowsing/model/rostering.models';
import {DistrictEntity} from '@app/views/databrowsing/model/common.data.models';
import {
    AssessmentLineItemModel,
    CategoryModel,
    LineItemModel,
    ScoreScaleModel
} from '@app/views/databrowsing/model/gradebook.models';
import {ResourceModel} from '@app/views/databrowsing/model/resource.models';
import {LinkedEntities} from '@app/views/databrowsing/model/linked-entities.models';
import {PagedDataItem} from '@app/views/databrowsing/model/paged-data';

@Pipe({
    name: 'ngcEntityDetailTitle'
})
export class EntityDetailTitlePipe implements PipeTransform {

    transform(data: PagedDataItem<DistrictEntity>, entity: string): string {
        let result = '';
        if (data && data.data) {
            switch (entity) {
                case 'assessment_line_items': {
                    const assessmentLineItem: AssessmentLineItemModel = <AssessmentLineItemModel>data.data;
                    result = assessmentLineItem.title;
                    break;
                }
                case 'assessment_results': {
                    const studentLink = LinkedEntities.getEntityLink(data, 'student', 'student');
                    const assessmentLineItemLink = LinkedEntities.getEntityLink(data, 'assessmentLineItem', 'assessmentLineItemId');
                    result = (studentLink.name && assessmentLineItemLink.name)
                        ? `${studentLink.name} - ${assessmentLineItemLink.name}`
                        : (studentLink.name || assessmentLineItemLink.name) ;
                    break;
                }
                case 'calendars': {
                    const calendar: CalendarModel = <CalendarModel>data.data;
                    const title = [];
                    if (calendar.title) {
                        title.push(calendar.title);
                    }
                    if (calendar.schoolYear) {
                        title.push(calendar.schoolYear);
                    }
                    result = title.join(', ');
                    break;
                }
                case 'categories': {
                    const category: CategoryModel = <CategoryModel>data.data;
                    result = category.title;
                    break;
                }
                case 'contacts':
                case 'school_admins':
                case 'staffs':
                case 'students': {
                    const person: Person = <Person>data.data;
                    if (person.name) {
                        result = `${person.name.givenName || ''} ${person.name.familyName || ''}`;
                    } else {
                        result = '';
                    }
                    break;
                }
                case 'courses': {
                    const course: CourseModel = <CourseModel>data.data;
                    result = course.courseTitle;
                    break;
                }
                case 'districts': {
                    const district: DistrictModel = <DistrictModel>data.data;
                    result = district.districtName;
                    break;
                }
                case 'groups': {
                    const group: GroupModel = <GroupModel>data.data;
                    result = group.name;
                    break;
                }
                case 'line_items': {
                    const lineItem: LineItemModel = <LineItemModel>data.data;
                    result = lineItem.title;
                    break;
                }
                case 'rosters': {
                    const roster: RosterModel = <RosterModel>data.data;
                    result = CustomerService.checkIsAmplifyCustomer() ? roster.sectionName : roster.sectionAlias;
                    break;
                }
                case 'schools': {
                    const school: SchoolModel = <SchoolModel>data.data;
                    result = school.schoolName;
                    break;
                }
                case 'resources': {
                    const resource: ResourceModel = <ResourceModel>data.data;
                    result = resource.title;
                    break;
                }
                case 'results': {
                    const studentLink = LinkedEntities.getEntityLink(data, 'student', 'student');
                    const lineItemLink = LinkedEntities.getEntityLink(data, 'lineItem', 'lineItem');
                    result = (studentLink.name && lineItemLink.name)
                        ? `${studentLink.name} - ${lineItemLink.name}`
                        : (studentLink.name || lineItemLink.name) ;
                    break;
                }
                case 'score_scales': {
                    const scoreScale: ScoreScaleModel = <ScoreScaleModel>data.data;
                    result = scoreScale.title;
                    break;
                }
                default: {
                    result = '';
                }
            }
        }
        return result;
    }

}
